import * as React from 'react'
import styled from 'styled-components'
import { ViewBase } from '@bestyled/primitives'
import {
  commonProps,
  CommonProps,
  flexItemProps,
  FlexItemProps
} from '@bestyled/system'

export interface ExpandedProps extends FlexItemProps, CommonProps {
  expand?: boolean
}

/** The Expanded component is a generic container that has margin, padding, width, height and position */
export const Expanded = styled(ViewBase<ExpandedProps>('Expanded'))`
  flex-grow: ${(props) => (props.expand ? '1' : null)};
  flex-shrink: ${(props) => (props.expand ? '1' : null)};
  ${flexItemProps} ${commonProps}
` as React.FC<ExpandedProps>

Expanded.defaultProps = {
  expand: true
}
